import { render, staticRenderFns } from "./user-profiles.vue?vue&type=template&id=775d89c8&scoped=true&"
import script from "./user-profiles.vue?vue&type=script&lang=js&"
export * from "./user-profiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d89c8",
  null
  
)

export default component.exports